import { createContext, ReactNode, useState } from "react";

const ROUTES = ["subscribe", "thanks"] as const;

type Route = typeof ROUTES[number];

interface NavigationProviderProps {
  children: ReactNode | ReactNode[];
}

interface NavigationContextProps {
  activeRoute: Route;
  setActiveRoute: (route: Route) => void;
}

const NavigationContext = createContext<NavigationContextProps>(
  {} as NavigationContextProps
);

const NavigationProvider: React.FC<NavigationProviderProps> = ({
  children,
}) => {
  const [activeRoute, setActiveRoute] = useState<Route>("subscribe");

  return (
    <NavigationContext.Provider value={{ activeRoute, setActiveRoute }}>
      {children}
    </NavigationContext.Provider>
  );
};

export { NavigationContext, NavigationProvider };
